// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HDDIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HDDIcon" ref={forwardedRef} {...props}>
      <path d="M10.5 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
      <path d="M12.5 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
      <path d="M3.5 3.5a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1zm1.5 7h10V4H5zM5 12v4h10v-4z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HDDIcon = /* @__PURE__ */ Object.assign(HDDIconComponent, {
  displayName: 'HDDIcon',
});
